import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './quasar';
import VueLazyLoad from 'vue-lazyload';
import VueAnalytics from 'vue-analytics';
import L from 'leaflet';

// FIX for leaflet/webpack marker bug
// see https://github.com/PaulLeCam/react-leaflet/issues/255
// @ts-ignore
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
    id: process.env.NODE_ENV === 'production' ? 'UA-45336474-1' : 'UA-183774000-1',
    // UA-183774000-1 is linked to chris@mapdev.ca account
});

Vue.use(VueLazyLoad);

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
